import { ref } from 'vue';
import VueRouter from 'vue-router';

/**
 * VueRouterを用いたダイアログ制御機能を提供
 * @param router {VueRouter}
 */
export const useDialogWithRouter = (router: VueRouter) => {
  const dialog = ref(false);

  const open = () => {
    dialog.value = true;
  };

  const close = () => {
    dialog.value = false;
  };

  const afterClose = () => {
    router.back();
  };

  return {
    dialog,
    open,
    close,
    afterClose,
  };
};
